@for (chunk of colorPresets() | chunks: columns(); track chunk; let firstRow = $first; let lastRow = $last) {
    <div class="presets-row" [ngClass]="{ 'first': firstRow, 'last': lastRow }">

        @for (preset of chunk; track preset; let firstColumn = $first; let lastColumn = $last;) {
            @if (isList(preset)) {
            <color-preset-sublist 
                [list]="preset" 
                [direction]="direction()"
                [activeColor]="color()"
                [ngClass]="{ 'first': firstColumn, 'last': lastColumn }"
                (selectionChange)="onSelectionChange($event)" />
            } @else {
                <color-preset 
                    [ngClass]="{ 'first': firstColumn, 'last': lastColumn }"
                    [color]="preset" 
                    [activeColor]="color()" 
                    (selectionChange)="onSelectionChange($event)" />
            }
        }
    </div>
}